<template>
  <div class="pdfdetails">
    <pdf ref="child" :res="res" />
  </div>
</template>

<script>
import pdf from "@/components/viewpdf.vue";
import Wx from "@/assets/js/wx";
export default {
  name: "pdfdetail",
  components: { pdf },
  data() {
    return {
      model: "",
      res: "",
      id: this.$route.query.id,
      userid: this.$cookie.getCookie("userid"),
      code: this.$route.query.code,
      baseHref: window.location.href, //当前页面URL
    };
  },
  mounted() {
    if (this.id != undefined && this.id != "") {
      this.getModel();
    }

    //登录校验
    if (!this.userid) {
      if (this.code) {
        //接口 code换openid
        this.getuserid();
      } else {
        Wx(this.baseHref); //静默授权
      }
    } 
  },
  methods: {
    getModel() {
      let params = {
        id: this.id,
      };
      this.$api.res.getModel(params).then((r) => {
        let { tag, data, message } = r;
        if (tag == 1) {
          console.log(data);
          this.model = data;
          if(this.$cookie.getCookie("userid")){
             this.handleClick(this.model)
          }
          this.res = data.resModel;
          document.title = this.res.catalogTitle + "-" + this.res.name;
        } else {
          Dialog.alert({
            title: "获取数据失败",
            message: message,
          }).then(() => {
            //刷新
          });
        }
      });
    },
    //获取登录信息
    async getuserid() {
      let params = {
        code: this.code,
      };
      const { data, tag, message } = await this.$api.res.getOpenid(params);
      if (tag == 1) {
        this.userid = data;
        this.$cookie.clearCookie("userid");
        this.$cookie.setCookie("userid", data);
        this.handleClick(this.model)
      } else {
        Toast(message);
      }
    },
    handleClick(info){
        try {
            this.$api.res.addLog({
                bookId: info.bookId,
                bookName: info.bookName,
                catalogId: info.resModel.catalogId,
                catalogName: info.resModel.catalogName,
                resId:info.resModel.id,
                resName:info.resModel.name,
                visitType: 2,
                openId:this.$cookie.getCookie("userid")
            })
        } catch (error) {
            console.log(error);
        }
    }
  },
};
</script>

<style lang="scss">
.pdfdetails {
  width: 100%;
  height: 100%;
}
</style>
